// CartContext.js
import {
  addToCart,
  getCartItem,
  getCartList,
  removeFromCart,
  updateCart,
} from "../http/cart/cart"
import React, { createContext, useEffect, useState } from "react"

const CartContext = createContext()

const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([])
  const [cartLength, setCartLength] = useState(0)

  useEffect(() => {
    setCartLength(cartItems?.length)
  }, [cartItems])

  const getCartItemDetail = async data => {
    try {
      const response = await getCartItem(data)
      return response.data.data
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  const getCartData = async () => {
    try {
      const response = await getCartList()
      setCartItems(response.data.data)
      return response
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  const addItemToCart = async data => {
    try {
      const response = await addToCart(data)
      return response
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  const removeItemFromCart = async data => {
    try {
      const response = await removeFromCart(data)
      return response;
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  const updateItemCart = async data => {
    try {
      const response = await updateCart(data)
      if(response.status) {
        return response
      }else {
        throw new Error(response.message);
      }
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  return (
    <CartContext.Provider
      value={{
        cartItems,
        getCartItemDetail,
        getCartData,
        addItemToCart,
        removeItemFromCart,
        updateItemCart,
        cartLength,
      }}
    >
      {children}
    </CartContext.Provider>
  )
}

export { CartProvider, CartContext }
